import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";

function ProjectDetails() {
  const { repoId } = useParams();
  const [repoDetails, setRepoDetails] = useState(null);

  useEffect(() => {
    fetch(`https://api.github.com/repos/sertacgltkn/${repoId}`)
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setRepoDetails(data);
      })
      .catch((error) => console.log(error));
  }, [repoId]);

  if (!repoDetails) {
    return <div>Loading...</div>;
  }

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { delay: 0.2, duration: 0.5 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.5 } }
  };

  return (
    <motion.div
      className="container"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.h2 className="title" variants={itemVariants}>
        {repoDetails.name}
      </motion.h2>
      <motion.p className="created" variants={itemVariants}>
        Created at: {repoDetails.created_at}
      </motion.p>
      <motion.p className="title" variants={itemVariants}>
        Title: {repoDetails.title}
      </motion.p>
      <motion.p
        className="centered-text text-white"
        style={{ textAlign: "center" }}
        variants={itemVariants}
      >
        This page is under construction.....!!!
      </motion.p>
    </motion.div>
  );
}

export default ProjectDetails;